let _initProto, _initClass, _init_value, _init_extra_value, _init_label, _init_extra_label, _init_placeholder, _init_extra_placeholder, _init_disabled, _init_extra_disabled, _init_openOnFocus, _init_extra_openOnFocus, _init_changeEvent, _init_extra_changeEvent, _init_rootTarget, _init_extra_rootTarget;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { textContains } from "@/lib/text-filter";
import { findAssociatedLabel, syncFieldLabel } from "../shared/field-label";
import { ListboxPopoverBehavior } from "../shared/listbox-popover-behavior";
let _RuiCombobox;
class RuiCombobox extends RadiantElement {
  static {
    ({
      e: [_init_value, _init_extra_value, _init_label, _init_extra_label, _init_placeholder, _init_extra_placeholder, _init_disabled, _init_extra_disabled, _init_openOnFocus, _init_extra_openOnFocus, _init_changeEvent, _init_extra_changeEvent, _init_rootTarget, _init_extra_rootTarget, _initProto],
      c: [_RuiCombobox, _initClass]
    } = _applyDecs(this, [customElement("rui-combobox")], [[prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "placeholder"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "openOnFocus"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [query({
      ref: "root"
    }), 0, "rootTarget"], [onUpdated(["value", "label", "placeholder", "disabled", "openOnFocus"]), 2, "onPropsUpdated"], [onEvent({
      ref: "root",
      type: "focusin"
    }), 2, "onRootFocusIn"], [onEvent({
      ref: "root",
      type: "input"
    }), 2, "onRootInput"], [onEvent({
      ref: "root",
      type: "keydown",
      options: {
        capture: true
      }
    }), 2, "onRootKeydown"], [onEvent({
      selector: "[data-combobox-trigger]",
      type: "click"
    }), 2, "onTriggerClick"], [onEvent({
      selector: '[data-combobox-listbox] [role="option"]',
      type: "pointerover"
    }), 2, "onOptionPointerOver"], [onEvent({
      selector: '[data-combobox-listbox] [role="option"]',
      type: "mousedown"
    }), 2, "onOptionMouseDown"], [onEvent({
      selector: '[data-combobox-listbox] [role="option"]',
      type: "click"
    }), 2, "onOptionClick"], [onEvent({
      ref: "root",
      type: "focusout"
    }), 2, "onFocusOut"], [onEvent({
      document: true,
      type: "pointerdown"
    }), 2, "onDocumentPointerDown"]], 0, void 0, RadiantElement));
  }
  constructor(...args) {
    super(...args);
    _init_extra_rootTarget(this);
  }
  value = (_initProto(this), _init_value(this));
  label = (_init_extra_value(this), _init_label(this));
  placeholder = (_init_extra_label(this), _init_placeholder(this));
  disabled = (_init_extra_placeholder(this), _init_disabled(this));
  openOnFocus = (_init_extra_disabled(this), _init_openOnFocus(this));
  changeEvent = (_init_extra_openOnFocus(this), _init_changeEvent(this));
  open = (_init_extra_changeEvent(this), false);
  skipNextFocusOpen = false;
  uid = Math.random().toString(36).slice(2, 9);
  listboxBehavior = new ListboxPopoverBehavior({
    getAnchor: () => this.rootTarget,
    getFloating: () => this.getListboxPopup(),
    getOpen: () => this.open,
    getOptions: () => this.getOptions(),
    getActiveDescendantHost: () => this.getInput(),
    getOptionIdPrefix: () => `rui-combobox-option-${this.uid}`
  });
  rootTarget = _init_rootTarget(this);
  get listboxId() {
    return `rui-combobox-list-${this.uid}`;
  }
  get inputId() {
    return `rui-combobox-input-${this.uid}`;
  }
  getInput() {
    return this.querySelector("[data-combobox-input]");
  }
  getTrigger() {
    return this.querySelector("[data-combobox-trigger]");
  }
  getListboxPopup() {
    return this.querySelector("[data-combobox-listbox]");
  }
  getListbox() {
    const host = this.querySelector("rui-listbox");
    if (host instanceof HTMLElement) {
      return host.querySelector('[role="listbox"]') ?? host;
    }
    return this.getListboxPopup();
  }
  getListboxHost() {
    return this.querySelector("rui-listbox");
  }
  getOptions() {
    const listbox = this.getListbox();
    if (!listbox) {
      return [];
    }
    return Array.from(listbox.querySelectorAll('[role="option"]'));
  }
  getOptionLabel(option) {
    return option.getAttribute("data-label") || option.textContent?.trim() || "";
  }
  ensureOptionIds() {
    this.listboxBehavior.ensureOptionIds();
  }
  getAccessibleName() {
    const labelElement = findAssociatedLabel(this);
    return labelElement?.textContent?.trim() || this.label || "Suggestions";
  }
  isComboboxInput(target) {
    return target instanceof HTMLElement && target.localName === "input" && target.hasAttribute("data-combobox-input");
  }
  syncLabel() {
    const input = this.getInput();
    syncFieldLabel(this, input, {
      controlId: this.inputId,
      label: this.label,
      labelId: `rui-combobox-label-${this.uid}`
    });
  }
  syncTrigger() {
    const trigger = this.getTrigger();
    const listbox = this.getListbox();
    if (!trigger || !listbox) {
      return;
    }
    trigger.setAttribute("aria-expanded", String(this.open));
    trigger.setAttribute("aria-controls", listbox.id || this.listboxId);
    trigger.tabIndex = -1;
    if (this.disabled) {
      trigger.disabled = true;
    }
  }
  syncInput() {
    const input = this.getInput();
    const listbox = this.getListbox();
    const popup = this.getListboxPopup();
    if (!input || !listbox) {
      return;
    }
    if (!input.id) {
      input.id = this.inputId;
    }
    if (!listbox.id) {
      listbox.id = this.listboxId;
    }
    input.setAttribute("role", "combobox");
    input.setAttribute("aria-haspopup", "listbox");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-expanded", String(this.open));
    input.setAttribute("aria-controls", this.listboxId);
    listbox.setAttribute("aria-label", this.getAccessibleName());
    if (popup) {
      popup.removeAttribute("role");
      popup.removeAttribute("aria-label");
    }
    if (this.placeholder && !input.placeholder) {
      input.placeholder = this.placeholder;
    }
    if (this.disabled) {
      input.disabled = true;
    }
    this.syncTrigger();
  }
  syncListboxHost() {
    const host = this.getListboxHost();
    if (!host) {
      return;
    }
    host.embedded = true;
    host.value = this.value;
  }
  syncOptionSelection() {
    for (const option of this.getOptions()) {
      const optionValue = option.getAttribute("data-value") || this.getOptionLabel(option);
      const isSelected = optionValue === this.value && this.value !== "";
      option.setAttribute("aria-selected", String(isSelected));
    }
  }
  setVisualFocusCombobox() {
    this.listboxBehavior.clearActiveOption();
    this.syncOptionSelection();
  }
  setOpen(next, options = {}) {
    const activate = options.activate ?? "none";
    this.open = next;
    const input = this.getInput();
    const popup = this.getListboxPopup();
    if (!input || !popup) {
      return;
    }
    input.setAttribute("aria-expanded", String(next));
    popup.toggleAttribute("hidden", !next);
    this.syncTrigger();
    if (!next) {
      this.listboxBehavior.clearActiveOption();
      this.listboxBehavior.syncPopoverPosition();
      return;
    }
    this.ensureOptionIds();
    this.listboxBehavior.syncPopoverPosition();
    if (activate === "first") {
      const visible = this.listboxBehavior.getVisibleOptions();
      this.listboxBehavior.setActiveOption(visible.length ? 0 : -1);
      return;
    }
    if (activate === "last") {
      const visible = this.listboxBehavior.getVisibleOptions();
      this.listboxBehavior.setActiveOption(visible.length ? visible.length - 1 : -1);
      return;
    }
    this.listboxBehavior.clearActiveOption();
  }
  getAutocomplete() {
    return this.querySelector("rui-autocomplete");
  }
  syncAutocompleteFilter() {
    const autocomplete = this.getAutocomplete();
    if (autocomplete) {
      autocomplete.syncFilter();
      return;
    }
    const query2 = this.getInput()?.value ?? "";
    for (const option of this.getOptions()) {
      const matches = textContains(this.getOptionLabel(option), query2, "base");
      option.hidden = query2.trim() !== "" && !matches;
    }
  }
  /** Restores the unfiltered collection when arrow navigation has no match to enter. */
  showAllOptions() {
    for (const option of this.getOptions()) {
      option.hidden = false;
    }
  }
  syncFilter() {
    this.syncAutocompleteFilter();
  }
  select(option) {
    if (option.getAttribute("aria-disabled") === "true") {
      return;
    }
    const value = option.getAttribute("data-value") || this.getOptionLabel(option);
    const label = this.getOptionLabel(option) || value;
    this.value = value;
    const input = this.getInput();
    if (input) {
      input.value = label;
    }
    this.changeEvent.emit({
      value
    });
    this.syncOptionSelection();
    this.skipNextFocusOpen = true;
    this.setOpen(false);
    input?.focus();
  }
  syncFromValue() {
    const input = this.getInput();
    if (!input) {
      return;
    }
    const match = this.getOptions().find(option => option.getAttribute("data-value") === this.value);
    const label = match ? this.getOptionLabel(match) : this.value || "";
    input.value = label;
  }
  initialize() {
    this.ensureOptionIds();
    this.syncLabel();
    this.syncInput();
    this.syncListboxHost();
    this.syncFromValue();
    this.syncOptionSelection();
    this.setOpen(false);
  }
  onConnected() {
    this.initialize();
  }
  disconnectedCallback() {
    this.listboxBehavior.destroy();
    super.disconnectedCallback();
  }
  onPropsUpdated() {
    this.syncLabel();
    this.syncInput();
    this.syncListboxHost();
    this.syncFromValue();
    this.syncOptionSelection();
  }
  onRootFocusIn(event2) {
    if (!this.isComboboxInput(event2.target)) {
      return;
    }
    if (this.skipNextFocusOpen) {
      this.skipNextFocusOpen = false;
      return;
    }
    if (!this.openOnFocus) {
      return;
    }
    this.syncFilter();
    this.setOpen(true);
    this.setVisualFocusCombobox();
  }
  onRootInput(event2) {
    if (!this.isComboboxInput(event2.target)) {
      return;
    }
    const input = event2.target;
    this.syncFilter();
    if (input.value.trim() !== "" && this.listboxBehavior.getVisibleOptions().length) {
      this.setOpen(true);
    } else if (input.value.trim() === "" && this.openOnFocus) {
      this.setOpen(true);
    } else if (input.value.trim() === "" || !this.listboxBehavior.getVisibleOptions().length) {
      this.setOpen(false);
    }
    this.setVisualFocusCombobox();
  }
  onRootKeydown(event2) {
    if (!this.isComboboxInput(event2.target)) {
      return;
    }
    this.handleInputKeydown(event2);
  }
  handleInputKeydown(event2) {
    if (event2.key === "Home") {
      const input = this.getInput();
      if (!input) {
        return;
      }
      event2.preventDefault();
      input.setSelectionRange(0, 0);
      this.setVisualFocusCombobox();
      return;
    }
    if (event2.key === "End") {
      const input = this.getInput();
      if (!input) {
        return;
      }
      event2.preventDefault();
      const length = input.value.length;
      input.setSelectionRange(length, length);
      this.setVisualFocusCombobox();
      return;
    }
    if (event2.key === "ArrowDown" || event2.key === "ArrowUp") {
      this.syncFilter();
      if (!this.listboxBehavior.getVisibleOptions().length) {
        this.showAllOptions();
      }
    }
    this.listboxBehavior.handleKeydown(event2, {
      isOpen: this.open,
      canUseSpace: false,
      closesOnTab: true,
      enterWhenClosed: "ignore",
      enterWithoutActive: "close",
      onOpen: (activation = "none") => {
        this.syncFilter();
        this.setOpen(true, {
          activate: activation
        });
      },
      onClose: () => this.setOpen(false),
      onSelectActive: () => {
        const option = this.listboxBehavior.getVisibleOptions()[this.listboxBehavior.activeOptionIndex];
        if (option) {
          this.select(option);
        }
      },
      onEscapeWhenClosed: () => {
        const input = this.getInput();
        if (input && input.value) {
          input.value = "";
          this.value = "";
          this.changeEvent.emit({
            value: ""
          });
          this.syncFilter();
        }
      }
    });
  }
  onTriggerClick(event2) {
    event2.preventDefault();
    const input = this.getInput();
    if (!input || input.disabled) {
      return;
    }
    if (this.open) {
      this.skipNextFocusOpen = true;
      this.setOpen(false);
    } else {
      this.syncFilter();
      this.setOpen(true);
      this.setVisualFocusCombobox();
    }
    input.focus();
  }
  onOptionPointerOver(event2) {
    if (!this.open) {
      return;
    }
    const option = event2.target.closest('[role="option"]');
    if (!option || option.getAttribute("aria-disabled") === "true" || option.hidden) {
      return;
    }
    const visible = this.listboxBehavior.getVisibleOptions();
    const index = visible.indexOf(option);
    if (index >= 0) {
      this.listboxBehavior.setActiveOption(index);
    }
  }
  onOptionMouseDown(event2) {
    event2.preventDefault();
  }
  onOptionClick(event2) {
    const option = event2.target.closest('[role="option"]');
    if (option) {
      this.select(option);
    }
  }
  onFocusOut(event2) {
    if (!this.listboxBehavior.shouldDismissFocus(event2.relatedTarget)) {
      return;
    }
    this.setOpen(false);
  }
  onDocumentPointerDown(event2) {
    if (!this.open) {
      return;
    }
    if (!this.listboxBehavior.shouldDismissPointer(event2.target)) {
      return;
    }
    this.setOpen(false);
  }
  static {
    _initClass();
  }
}
export { _RuiCombobox as RuiCombobox };